import isEqual from "lodash-es/isEqual";

import WeeklyReportSetting from "@app/types/report/WeeklyReportCardSettings";

// could be just isEqual, but we need to compare config arrays without respeciting the order
const isWeeklyReportSettingEqual = (
  a: WeeklyReportSetting["value"],
  b: WeeklyReportSetting["value"]
): boolean =>
  a.enabled === b.enabled &&
  a.quickFigures.enabled === b.quickFigures.enabled &&
  a.actionItems === b.actionItems &&
  a.leaderboardAttachment === b.leaderboardAttachment &&
  a.teamLeaderboard.enabled === b.teamLeaderboard.enabled &&
  isEqual([...a.quickFigures.config].sort(), [...b.quickFigures.config].sort()) &&
  isEqual([...a.teamLeaderboard.config].sort(), [...b.teamLeaderboard.config].sort()) &&
  a.teamLeaderboard.leaderboardComparison === b.teamLeaderboard.leaderboardComparison &&
  a.teamLeaderboard.resultsCapped === b.teamLeaderboard.resultsCapped;

export default isWeeklyReportSettingEqual;
